import actionCreatorFactory from "typescript-fsa";
import { CartoData } from "./types";

const actionCreator = actionCreatorFactory("@@Carto");

export const cartoActions = {
  fetchCartoData: actionCreator.async<{}, { carto: CartoData[] }>("FETCH_CARTO_DATA"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
